import { Button, type ButtonProps, styled } from '@mui/material';

const StyledButton = styled(Button)({
  borderRadius: 0,
  marginTop: 24,
  width: '100%',
});

type PrimaryButtonProps = ButtonProps & {
  readonly isLoading?: boolean;
};

const PrimaryButton = ({ children, isLoading, disabled, ...props }: PrimaryButtonProps) => (
  <StyledButton variant="contained" disabled={disabled ?? isLoading} {...props}>
    {children}
  </StyledButton>
);

export default PrimaryButton;
